import { Object } from '@common/Object/Object'

import type { IAnimRunProps, TAnimName } from '@common/Anim/Anim'
import Anim from '@common/Anim/Anim'

interface IAnim {
  [propName: string]: any // eslint-disable-line @typescript-eslint/no-explicit-any
  readonly add: (
    el: Element | null,
    name: TAnimName,
    duration: number,
    isForce?: boolean,
    willRemoveClass?: boolean
  ) => Promise<void>
}

const anim: IAnim = {
  /**
   * Az Ügyesedni játékok saját animációs utility-je.
   * @param el - Animálandó Element.
   * @param name - Anim neve.
   * @param duration - Animáció hossza.
   * @param isForce - Force?
   * @param willRemoveClass - Leszedjük a classt az anim végén?
   */

  add: (
    el: Element | null,
    name: TAnimName,
    duration: number,
    isForce?: boolean,
    willRemoveClass?: boolean
  ): Promise<void> => {
    const animProps: IAnimRunProps = {
      el,
      name,
      duration,
      isForce: isForce ?? false,
      willRemoveClass: willRemoveClass ?? true
    }

    return Anim.run(animProps)
  }
}

// Az összes EAnim animációt hozzácsapjuk az object-hez, hogy azon keresztül elérhetőek legyenek
Object.getKeys(Anim.ANIMS).forEach((key) => {
  anim[key] = (Anim.ANIMS as TAnyObject)[key]
})

export default anim
